import { render, staticRenderFns } from "./CreateStockingsModal.vue?vue&type=template&id=886deffa&scoped=true&"
import script from "./CreateStockingsModal.vue?vue&type=script&lang=js&"
export * from "./CreateStockingsModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateStockingsModal.vue?vue&type=style&index=0&id=886deffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886deffa",
  null
  
)

export default component.exports